import { api } from "../../http";

async function PostDataAllRRIM(data) {
  try {

    const rrim = await api.post("/rrim/", data);
    return rrim;

  } catch (e) {
    console.log(e.message);
  }
}

export { PostDataAllRRIM };
